export const PageTitle = (props: { 
    children: React.ReactNode,
    className?: string
}) => {
    const { 
        children,
        className
    } = props;

    return (
        <div className={`font-bold text-2xl mr-auto text-focus-blue ${className}`}>
            {children}
        </div>
    );
}

export const Text = (props: { 
    children: React.ReactNode,
    className?: string
}) => {
    const { 
        children,
        className
    } = props;

    return (
        <div className={`font-normal text-gray-500 text-md mb-3 text-left ${className}`}>
            {children}
        </div>
    );
}